// Module
var code = "<section class=\"not-authorized\"> {{ 'core.not_authorized' | translate }} <a href=\"www.html\">{{ 'core.back_to_home' | translate }}</a> </section> ";
// Exports
export default code;